import { DispenserDetailResponse, DispenserEvent } from '@/features/dispensers/services/schemas.ts';
import Chip from '@mui/material/Chip';
import { Trans } from '@lingui/react/macro';
import { differenceInHours } from 'date-fns/differenceInHours';
import { EventResultEnum } from '@/features/events/types/EventResult.ts';
import { useNow } from '@/common/hooks/useNow.ts';

export interface DispenserStatusChipProps {
  dispenser: Pick<DispenserDetailResponse, 'collector' | 'lastMessageReceivedAt'>;
  lastEvent: DispenserEvent | null;
}

export const DispenserStatusChip = ({ dispenser, lastEvent }: DispenserStatusChipProps) => {
  const now = useNow();

  if (dispenser.collector === null) {
    return null;
  }

  if (
    !dispenser.lastMessageReceivedAt ||
    differenceInHours(now, dispenser.lastMessageReceivedAt) >= 1
  ) {
    return <Chip label={<Trans>Not responding</Trans>} size="small" component="span" />;
  }

  if (lastEvent) {
    if (lastEvent.result === EventResultEnum.E_OK) {
      return <Chip label={<Trans>OK</Trans>} size="small" color="success" component="span" />;
    }

    if (lastEvent.result === EventResultEnum.E_USER_ABORTED) {
      return <Chip label={<Trans>Aborted</Trans>} size="small" color="success" component="span" />;
    }

    if ((lastEvent.result === 1 && lastEvent.eventType === 1) || lastEvent.result > 0) {
      return <Chip label={<Trans>Error</Trans>} size="small" color="error" component="span" />;
    }
  }

  return <Chip label={<Trans>Unknown</Trans>} size="small" color="warning" component="span" />;
};
